export const createSilentSetError = () => {
	let captured = false;

	const setError = () => {
		captured = true;
	};

	return {
		setError,
		hasError: () => captured,
	};
};

export const runSilentValidation = (validators) => {
	for (const validator of validators) {
		const { setError, hasError } = createSilentSetError();
		const result = validator(setError);

		if (result === false || hasError()) {
			return false;
		}
	}

	return true;
};
